import { Component } from "react";
import { Editor, EditorState, convertFromRaw } from "draft-js";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import 'draft-js/dist/Draft.css';
import { HalCompassReportGenerator } from "../../../e-learning/ecert/HalCompassReportGenerator";
import bgLogo from '../../../e-learning/ecert/HA_WHITE_LOGO.png';
import logo2 from '../../../e-learning/ecert/HALCOMPASS_OUTLINED_WHITE.png'
// import bgLogo from './HA_WHITE_LOGO.png'

class HalCompassInitReport extends Component {

    render() {
        const { selectedReportData, formattedDate, formattedTime } = this.props;
        return (
            <div>
                {selectedReportData ? (
                    <div>
                        <div style={{ border: '1px solid #8f8f8f' }}>
                            <div style={{ backgroundColor: '#239156', position: 'relative', height: '150px', width: '100%', marginBottom: '20px' }}>
                                <div className="d-flex justify-content-end align-items-center" style={{ position: 'absolute', width: '100%', height: '100%', right: '10px' }}>
                                    <img src={bgLogo} alt="" width={'120px'} height={'120px'} style={{ opacity: '0.2', objectFit: 'contain' }} />
                                </div>
                                <div className="d-flex justify-content-start align-items-center" style={{ position: 'relative', height: '100%', paddingLeft: '20px', gap: '20px' }}>
                                    <img src={logo2} alt="" style={{ backgroundColor: 'white', borderRadius: '15px', padding: '25px', width: '20vw', height: 'auto' }} />
                                    <div className="d-flex flex-column justify-content-center align-items-middle" style={{ color: 'white', fontWeight: '800', }}>
                                        <p style={{ fontSize: '2.5vw', lineHeight: '1.2', margin: 0 }}>
                                            Penilaian<br />
                                            Kesediaan Halal
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="px-3">
                                <div className="d-flex flex-column p-3" style={{ border: '3px solid', borderRadius: '30px' }}>
                                    <div className="text-center">
                                        <h4><span className="text-green">Keputusan</span> Kesediaan Halal</h4>
                                    </div>
                                    <div className="text-center p-2 text-white" style={{ borderRadius: '50px', backgroundColor: '#239156' }}>
                                        Skor Kelayakan Permohonan Halal
                                    </div>
                                    <div className="text-center">
                                        <div className="my-2">
                                            <h4><b>JULAT SKOR:</b></h4>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            {selectedReportData.rankings.map(ranking =>
                                                <div key={ranking.id} className={
                                                    ranking.title === 'Tidak Bersedia' ? 'mx-2 text-red' :
                                                        ranking.title === 'Asas' ? 'mx-2 text-pinktext' :
                                                            ranking.title === 'Berkemampuan' ? 'mx-2 text-yellow' :
                                                                'mx-2 text-green'}>
                                                    <b>{ranking.minPercentage} - {ranking.maxPercentage} : {ranking.title}</b>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <table className="text-center mt-3 p-2 reportTable table" >
                                        <thead>
                                            <tr style={{ backgroundColor: '#0f4694', color: 'white' }}>
                                                <th className="col-2">
                                                    Jumlah Skor
                                                </th>
                                                <th className="col-10" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                    Tahap Kesediaan
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                    <b style={{ fontSize: '20px' }}>{selectedReportData.percentageScore}</b>
                                                </td>
                                                <td className="text-left" style={{ textAlign: 'justify', backgroundColor: '#ffba00' }}>
                                                    <span>Tahap kesediaan yang <b>{selectedReportData.selectedRanking.title.toUpperCase()}</b>.<br /> {selectedReportData.selectedRanking.description}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table className="text-center p-2 reportTable table">
                                        <thead>
                                            <tr style={{ backgroundColor: '#0f4694', color: 'white' }}>
                                                <th>
                                                    Tindakan Selanjutnya
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div>
                                                        <Editor className="editor-arrow-cursor" editorState={EditorState.createWithContent(convertFromRaw(selectedReportData.selectedRanking.action))}
                                                            readOnly={true}
                                                            onChange={() => { }}></Editor>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex justify-content-between py-3" style={{ gap: '3px' }} >
                                    <div className="col-md-6 p-3 d-flex flex-column align-items-center" style={{ border: '3px solid', borderRadius: '30px' }}>
                                        <h3 style={{ color: '#239156', fontWeight: "bold", fontSize: '33px' }}>
                                            Maklumat Syarikat
                                        </h3>
                                        <div className="p-1 m-1 companyDetail" >
                                            <i className="fa fa-clock mr-2 text-green" />{formattedDate} {formattedTime}
                                        </div>
                                        <div className="p-1 m-1 companyDetail" >
                                            <i className="fa fa-circle mr-2 text-green" />{selectedReportData.companyProfile.name}
                                        </div>
                                        <div className="p-1 m-1 companyDetail">
                                            <a
                                                href={
                                                    selectedReportData.companyProfile.website.startsWith('http')
                                                        ? selectedReportData.companyProfile.website
                                                        : 'https://' + selectedReportData.companyProfile.website
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fa fa-globe mr-2 text-green" />
                                                {selectedReportData.companyProfile.website}
                                            </a>
                                        </div>
                                        <div className="p-1 m-1 companyDetail">
                                            <i className="fa fa-user mr-2 text-green" />{selectedReportData.userFullName}
                                        </div>
                                        <div className="p-1 m-1 companyDetail">
                                            <i className="fa fa-phone mr-2 text-green" />{selectedReportData.companyProfile.phoneNumber}
                                        </div>
                                        <div className="p-1 m-1 companyDetail">
                                            <i className="fa fa-users mr-2 text-green" />{selectedReportData.companyProfile.staffTotal}
                                        </div>
                                        <div className="p-1 m-1 companyDetail">
                                            <i className="fa fa-briefcase mr-2 text-green" />{selectedReportData.companyProfile.shift} Shifts
                                        </div>
                                        <div className="p-1 m-1 d-flex align-items-center companyDetail">
                                            <div>
                                                <i className="fa fa-industry mr-2 text-green" />
                                            </div>
                                            <div>
                                                {selectedReportData.companyProfile.industrialCategory}
                                            </div>
                                        </div>
                                        <div className="p-1 m-1 companyDetail" >
                                            <i className="fa fa-file mr-2 text-green" />{selectedReportData.selectedScheme.name}
                                        </div>
                                    </div>
                                    <div className="col-md-6 p-4 d-flex flex-column justify-content-around align-items-center" style={{ border: '3px solid', borderRadius: '30px' }}>
                                        <div >
                                            <div className="text-center mb-4" style={{ fontSize: '20px', fontWeight: '900' }}>Keputusan Skor Kriteria Penilaian</div>
                                            <div>
                                                <ul>
                                                    {selectedReportData.selectedAnswers.map((selectedAnswer, selectedAnswerIndex) =>
                                                        <li key={selectedAnswerIndex}>
                                                            <b>{selectedAnswer.criteria}</b>: {selectedAnswer.percentageCreteriaScore}%
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                        <div style={{ textAlign: 'justify' }}><b>Catatan:</b> Keputusan skor mengikut krieria ini bertujuan untuk menerangkan tahap pematuhan
                                            terhadap setiap keperluan utama dalam
                                            pensijilan halal. Peratusan yang ditunjukkan
                                            mencerminkan sejauh mana organisasi telah
                                            bersedia untuk memenuhi kehendak pensijilan
                                            tersebut</div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end">
                        <PDFDownloadLink fileName={`${selectedReportData.companyProfile.name} HalComPASS Report`} document={<HalCompassReportGenerator selectedReportData={selectedReportData} formattedDate={formattedDate} formattedTime={formattedTime} />}>
                                <button className="btn all-btn"> <i className="fas fa-download" />{' '}Full Report</button>
                            </PDFDownloadLink>
                            
                        {/* <div className="d-flex justify-content-end" style={{ height: '100vh' }}>
                            <PDFViewer width={'100%'} height={'100%'}><HalCompassReportGenerator selectedReportData={selectedReportData} formattedDate={formattedDate} formattedTime={formattedTime} /></PDFViewer> */}

                        </div>
                    </div>


                ) : (<div>No Data</div>)}
            </div>
        )
    }
}

export default HalCompassInitReport